import { UiComponentProps } from '../../types'

import GreenStatus from './GreenStatus'
import GreyStatus from './GreyStatus'

const uiStatusComponents = [GreenStatus, null, null, GreyStatus]

function UiStatus({ uiDevice }: UiComponentProps) {
  const UIStatusComponent = uiStatusComponents[uiDevice?.Status?.value]

  if (UIStatusComponent) {
    return <UIStatusComponent />
  }

  return null
}

export default UiStatus
